(() => {
  const initProductVideoAutoplay = () => {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const videoSlides = document.querySelectorAll('.template-product .product__slide[data-video]');
    if (!videoSlides.length) return;

    const playbackState = new WeakMap();

    const prepareVideo = (slide) => {
      let video = slide.querySelector('video');

      if (!video) {
        const deferredMedia = slide.querySelector('deferred-media');

        if (!deferredMedia) return null;

        if (!deferredMedia.hasAttribute('loaded')) {
          const templateVideo = deferredMedia.querySelector('template')?.content.querySelector('video');
          if (templateVideo) {
            templateVideo.autoplay = false;
            templateVideo.removeAttribute('autoplay');
          }

          deferredMedia.loadContent(false);
        }

        video = slide.querySelector('video');
      }

      if (!video) return null;

      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.muted = true;
      video.playsInline = true;
      video.preload = 'auto';

      if (!playbackState.has(video)) {
        playbackState.set(video, {shouldPlay: false, waitingForFrame: false});
        video.load();
      }

      return video;
    };

    const playVisibleVideo = (slide) => {
      const video = prepareVideo(slide);
      if (!video) return;

      const state = playbackState.get(video);
      state.shouldPlay = true;

      const play = () => {
        if (!state.shouldPlay || !video.paused) return;

        const playPromise = video.play();
        if (playPromise) playPromise.catch(() => {});
      };

      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        play();
        return;
      }

      if (state.waitingForFrame) return;
      state.waitingForFrame = true;

      video.addEventListener(
        'loadeddata',
        () => {
          state.waitingForFrame = false;
          requestAnimationFrame(play);
        },
        {once: true}
      );
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
            playVisibleVideo(entry.target);
            return;
          }

          const video = entry.target.querySelector('video');
          if (!video) return;

          const state = playbackState.get(video);
          if (state) state.shouldPlay = false;
          video.pause();
        });
      },
      {threshold: [0, 0.55, 1], rootMargin: '120px 0px'}
    );

    videoSlides.forEach((slide) => observer.observe(slide));
  };

  const initWhenReady = () => {
    customElements.whenDefined('deferred-media').then(initProductVideoAutoplay);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady, {once: true});
  } else {
    initWhenReady();
  }
})();
